<template>
    <!-- Operator Data Divider -->
    <divider-generic
    icon="person"
    :title="t('approvals.operators.operatorDetails.operatorDataTitle')"/>
    <!-- Username -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.usernameLabel'), content: operatorDetails.username }"/>
    <!-- Name -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.nameLabel'), content: operatorDetails.name }"/>
    <!-- Email -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.emailLabel'), content: operatorDetails.email }"/>
    <!-- Phone -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.phoneLabel'), content: operatorDetails.msisdn }"/>
    <!-- Nif -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.nifLabel'), content: operatorDetails.nif ? operatorDetails.nif : '-' }"/>
    <!-- Password button -->
    <label-generic :text="t('approvals.operators.operatorDetails.passwordLabel')"/>
    <button-tertiary
    style="margin-top: -14px;"
    :label="t('approvals.operators.operatorDetails.changePassword')"
    @clicked="emit('resetPassword')"/>
    <!-- Access To New Accounts -->
    <text-block-generic
    :params="{
        label: t('approvals.operators.operatorDetails.accessToNewAccountsLabel'),
        content: operatorDetails.accessToNewAccounts ? t('approvals.operators.operatorDetails.yes') : t('approvals.operators.operatorDetails.no')
    }"/>
    <!-- Profile -->
    <text-block-generic
    :params="{ label: t('approvals.operators.operatorDetails.profileLabel'), content: operatorDetails.profile?.operatorProfileDescription || '-' }"/>
    <!-- Weight -->
    <text-block-generic
    v-if="operatorDetails.profileId === 1"
    :params="{ label: t('approvals.operators.operatorDetails.weightLabel'), content: `${operatorDetails.weight}%` }"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import LabelGeneric from '@/components/generic/labels/Generic'
import ButtonTertiary from '@/components/generic/buttons/Tertiary'
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['resetPassword'])

const props = defineProps({
    operatorDetails: Object
})
</script>

<style lang="scss" scoped>
</style>
